import { render, staticRenderFns } from "./RequestHistory.vue?vue&type=template&id=30f6f56c&scoped=true&"
import script from "./RequestHistory.vue?vue&type=script&lang=js&"
export * from "./RequestHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f6f56c",
  null
  
)

export default component.exports